document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("bdSunRxModal");
  if (!modal) return;

  const BD_SUN_VARIANTS = {
    "Grau":  53753543000391,
    "Braun": 53753543033159,
    "Grün":  53753543065927,
  };
  const SUN_LENS_PRICE = "59.90";

  const stepColor    = document.getElementById("bdSunStepColor");
  const stepRx       = document.getElementById("bdSunStepRx");
  const stepRxUpload = document.getElementById("bdSunStepRxUpload");

  const colorNext      = document.getElementById("bdSunColorNext");
  const rxBack         = document.getElementById("bdSunRxBack");
  const rxNext         = document.getElementById("bdSunRxNext");
  const rxUploadBack   = document.getElementById("bdSunRxUploadBack");
  const rxUploadNext   = document.getElementById("bdSunRxUploadNext");

  const rxFile = document.getElementById("bdSunRxFile");

  // Open trigger — registered early so it works regardless of form state
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-open-sun-rx-modal]")) {
      e.preventDefault();
      openModal();
    }
  });

  const productForm =
    document.querySelector('form[data-type="add-to-cart-form"]') ||
    document.querySelector("product-form form") ||
    document.querySelector('form[action^="/cart/add"]');

  if (!productForm) return;

  let selectedColor   = null;
  let selectedVariant = null;
  let isAdding        = false;
  let rxMethod        = null; // 'upload' | 'later'

  function hideAllSteps() {
    [stepColor, stepRx, stepRxUpload].forEach(s => s && (s.style.display = "none"));
  }

  function openModal() {
    modal.style.display = "block";
    modal.setAttribute("aria-hidden", "false");
    showStepColor();
  }

  function closeModal() {
    modal.style.display = "none";
    modal.setAttribute("aria-hidden", "true");
  }

  function showStepColor() {
    hideAllSteps();
    if (stepColor) stepColor.style.display = "block";
    if (colorNext) colorNext.disabled = true;
    selectedColor = null;
    selectedVariant = null;
    document.querySelectorAll("#bdSunStepColor .bd-usagecard").forEach(b => b.classList.remove("is-selected"));
    document.querySelectorAll('input[name="bdSunRxMethod"]').forEach(i => i.checked = false);
    if (rxFile) rxFile.value = "";
  }

  function showStepRx() {
    hideAllSteps();
    if (stepRx) stepRx.style.display = "block";
    if (rxNext) rxNext.disabled = true;
    document.querySelectorAll('input[name="bdSunRxMethod"]').forEach(i => i.checked = false);
    if (rxFile) rxFile.value = "";
  }

  function showStepRxUpload() {
    hideAllSteps();
    if (stepRxUpload) stepRxUpload.style.display = "block";
    validateRxUpload();
  }

  function validateRxUpload() {
    if (rxUploadNext) rxUploadNext.disabled = !(rxFile?.files?.length);
  }

  async function parseCartError(res) {
    const text = await res.text();
    try {
      const json = JSON.parse(text);
      return json.description || json.message || text;
    } catch (_) {
      const match = text.match(/<title>(.*?)<\/title>/i);
      return match ? match[1] : "Unbekannter Fehler";
    }
  }

  async function addToCart(properties, fileInput) {
    if (isAdding) return;
    isAdding = true;

    try {
      const mainVariantId = productForm.querySelector('[name="id"]')?.value;
      if (!mainVariantId) throw new Error("Kein Variant ID gefunden.");

      const hasFile = fileInput && fileInput.files && fileInput.files.length;
      if (hasFile) {
        const fd = new FormData();
        fd.set("id", mainVariantId);
        fd.set("quantity", "1");
        Object.entries(properties).forEach(([k, v]) => fd.set(`properties[${k}]`, v));
        fd.set("properties[Sehtest Upload]", fileInput.files[0]);
        const res = await fetch("/cart/add", {
          method: "POST",
          body: fd,
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        if (!res.ok) throw new Error(await parseCartError(res));
      } else {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ id: parseInt(mainVariantId), quantity: 1, properties }),
        });
        if (!res.ok) throw new Error(await parseCartError(res));
      }

      const resAddon = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({
          id: selectedVariant,
          quantity: 1,
          properties: {
            "Add-on für Variant": String(mainVariantId),
            "Add-on für Produkt": document.title || "Brille",
          },
        }),
      });
      if (!resAddon.ok) throw new Error(await parseCartError(resAddon));

      window.location.href = "/cart";
    } catch (err) {
      console.error(err);
      alert("Fehler: " + (err && err.message ? err.message : String(err)));
      isAdding = false;
    }
  }

  // Close
  modal.addEventListener("click", function (e) {
    if (e.target && e.target.hasAttribute("data-bd-sun-close")) closeModal();
  });

  // Step 1: Color
  document.querySelectorAll("#bdSunStepColor .bd-usagecard").forEach(btn => {
    btn.addEventListener("click", () => {
      document.querySelectorAll("#bdSunStepColor .bd-usagecard").forEach(b => b.classList.remove("is-selected"));
      btn.classList.add("is-selected");
      selectedColor   = btn.getAttribute("data-sun-color");
      selectedVariant = parseInt(btn.getAttribute("data-sun-variant"));
      if (colorNext) colorNext.disabled = false;
    });
  });

  if (colorNext) colorNext.addEventListener("click", () => selectedColor && showStepRx());

  // Step 2: Rx method
  if (rxBack) rxBack.addEventListener("click", showStepColor);

  document.querySelectorAll('input[name="bdSunRxMethod"]').forEach(radio => {
    radio.addEventListener("change", () => { if (rxNext) rxNext.disabled = false; });
  });

  // Letzter Schritt (Sehstärke übermitteln) führt direkt in den Warenkorb —
  // PD wird hier nicht mehr erhoben; falls sie im eingereichten Sehtest fehlt,
  // wird der Kunde nach dem Kauf separat kontaktiert.
  function finalizeOrder() {
    const props = {
      "Glasfarbe": selectedColor,
      "Gläserpaket Aufpreis (CHF)": SUN_LENS_PRICE,
    };
    if (rxMethod === "upload") {
      props["Sehstärke übermittelt"] = "Sehtest Upload";
    } else {
      props["Sehstärke"] = "Wird später per E-Mail eingereicht";
    }
    closeModal();
    addToCart(props, rxMethod === "upload" ? rxFile : null);
  }

  if (rxNext) {
    rxNext.addEventListener("click", () => {
      const method = document.querySelector('input[name="bdSunRxMethod"]:checked')?.value;
      rxMethod = method;
      if (method === "upload") showStepRxUpload();
      if (method === "later")  finalizeOrder();
    });
  }

  // Step 3b: Upload
  if (rxUploadBack) rxUploadBack.addEventListener("click", showStepRx);
  rxFile?.addEventListener("change", validateRxUpload);

  if (rxUploadNext) {
    rxUploadNext.addEventListener("click", () => {
      if (!rxFile?.files?.length) return;
      finalizeOrder();
    });
  }
});
